
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/cockroachdb",
      function () {
        return require("private-next-pages/destinations/cockroachdb.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/cockroachdb"])
      });
    }
  